













import {
    Vue, Component, Inject,
} from 'vue-property-decorator';
import { CASE_TIME_CONTEXT } from "../../constatnts";
import type { Context } from "../../context";
import type { Duration } from '../../utils/Timer';
import {i18nOption} from "../../i18n/i18n";

@Component({
    name: 'CaseTimeClock',
    components: {},
    i18n: i18nOption,
})
class CaseTimeClockImpl extends Vue {
    @Inject(CASE_TIME_CONTEXT)
    context!: Context

    tickTime = ''
    days = 0
    created() {
        this.refreshTextUnsub = this.context.Service.timer.getDurationFormattedSubscription((duration) => {
            this.updateHoverLabel(duration);
        });
    }

    beforeDestroy() {
        if(this.refreshTextUnsub) {
            console.log('end')
            this.refreshTextUnsub()
        }
    }

    updateHoverLabel(duration: Duration) {
        this.tickTime = duration.hours
        this.days = duration.days
    }
}
export default CaseTimeClockImpl;
